module.exports = __webpack_public_path__ + "img/green.7366e75a.png";